import { useEffect, useRef } from 'react';

import { type BackHandler, BackPriority, registerBackHandler } from './backChain';

export interface UseBackHandlerOptions {
  priority?: number;
  /** Set false to temporarily drop out of the chain without unmounting. */
  enabled?: boolean;
}

/** Registers `handler` in the back chain while mounted. The latest handler is always used. */
export function useBackHandler(
  handler: BackHandler,
  { priority = BackPriority.screen, enabled = true }: UseBackHandlerOptions = {},
): void {
  const ref = useRef(handler);
  useEffect(() => {
    ref.current = handler;
  });
  useEffect(() => {
    if (!enabled) return undefined;
    return registerBackHandler(() => ref.current(), priority);
  }, [priority, enabled]);
}
